import { render, staticRenderFns } from "./AlgebraicExpressionViz.vue?vue&type=template&id=2b5e5b16&scoped=true"
import script from "./AlgebraicExpressionViz.vue?vue&type=script&lang=js"
export * from "./AlgebraicExpressionViz.vue?vue&type=script&lang=js"
import style0 from "./AlgebraicExpressionViz.vue?vue&type=style&index=0&id=2b5e5b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e5b16",
  null
  
)

export default component.exports